module.exports = __webpack_public_path__ + "img/sa.414f5a6a.svg";